import React, { Component } from "react";
import TacForm from "../components/form";
import { Link } from "react-router-dom";
import { Email, Instagram, Snapchat, Tiktok, Twitter } from "../constants/icons";

export default class ContactPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: "",
        email: "",
        message: "",
      },
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  render() {
    const { formData } = this.state;

    const fields = [
      {
        name: "name",
        label: "Name",
        type: "text",
        required: true,
        autoComplete: "name",
      },
      {
        name: "email",
        label: "Email",
        type: "email",
        required: true,
        autoComplete: "email",
      },
      {
        name: "select",
        label: "Select a reason for contacting us today",
        type: "select",
        options: ["Join as an Artist", "General Enquiry"],
        required: true,
        autoComplete: "message",
      },
      {
        name: "message",
        label: "Your message",
        type: "textarea",
        required: true,
        autoComplete: "message",
      },
    ];

    return (
      <>
        {" "}
        <div className="contact-page-container">
          <img className="leaves small-leaves small-right-leaves" src="https://d1g9iww9o5ioh1.cloudfront.net/leaves/rightSmallLeaves.webp" alt="" />
          <section className="contact-hero" id="hero">
            <h1 className="page-header">Contact Us</h1>
          </section>
          <div className="contact-content-container">
            <section className="contactform contact-section">
              <div className="form" id="contact-form">
                <TacForm
                  fields={fields}
                  formid="Contact"
                  // first="Contact Us"
                  formData={formData}
                  onChange={this.handleChange}
                />
              </div>
            </section>
            <section className="contact-links contact-section">
              <h4>Send us an email</h4>
              <div className="contact-link-item">
                {" "}
                <Email className="contact-icon" />
                <span>management@wearedfg.com</span>
              </div>
              <h4>Follow us</h4>
              <div className="contact-link-item-container">
                <div className="contact-link-item">
                  <Link to="https://www.instagram.com/theafrocollective_?igsh=MTI2YXVybHd5MHUycg==">
                    <Instagram className="contact-icon" />
                    <span>@theafrocollective_</span>
                  </Link>
                </div>

                <div className="contact-link-item">
                  <Link to="https://www.tiktok.com/@theafrocollective?_t=ZG-8sKiwIgkxaC&_r=1">
                    <Tiktok className="contact-icon" />
                    <span>@theafrocollective</span>
                  </Link>
                </div>

                <div className="contact-link-item">
                  <Link to="https://x.com/afrocollective_?s=21&t=-zqnoi5XgftC8eHr9Aeu1w">
                    <Twitter className="contact-icon" />
                    <span>@AfroCollective</span>
                  </Link>
                </div>
                <div className="contact-link-item">
                  <Link to="https://www.snapchat.com/add/afro.collective">
                    <Snapchat className="contact-icon" />
                    <span>@afro.collective</span>
                  </Link>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }
}
